import ReactMarkdown, { defaultUrlTransform } from "react-markdown";
import remarkGfm from "remark-gfm";
import "./MarkdownRenderer.css";

const ALLOWED_DATA_IMAGE_PATTERN =
  /^data:image\/(png|jpeg|jpg|gif|webp|bmp);base64,/i;

function markdownUrlTransform(url, key) {
  if (key === "src" && ALLOWED_DATA_IMAGE_PATTERN.test(url)) {
    return url;
  }

  return defaultUrlTransform(url);
}

export default function MarkdownRenderer({ content = "" }) {
  return (
    <div className="markdown-renderer">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        urlTransform={markdownUrlTransform}
        components={{
          a: ({ node, children, ...props }) => (
            <a {...props} target="_blank" rel="noreferrer noopener">
              {children}
            </a>
          ),
          img: ({ node, alt, ...props }) => (
            <img {...props} alt={alt ?? ""} loading="lazy" />
          ),
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
